class PressBlog extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.press-grid-container');
    this.articles = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.groupBy = this.dataset.groupBy;

    this.sortAndRender();
  }

  renderArticle(article) {
    const url = article.external_link || article.url;
    const target = article.external_link ? 'target="_blank" rel="noopener"' : '';
    return `
      <div class="press-grid__item">
        <a href="${url}" class="press-grid__item-link" ${target}>
          ${article.excerpt ? `<div class="press-grid__excerpt rte">${article.excerpt}</div>` : ''}
          <h3 class="press-grid__title h4">${article.title}</h3>
        </a>
      </div>
    `;
  }

  sortAndRender() {
    this.articles.sort((a, b) => new Date(b.date) - new Date(a.date));

    const articlesByYear = this.articles.reduce((acc, article) => {
      const year = new Date(article.date).getFullYear().toString();
      if (!acc[year]) {
        acc[year] = [];
      }
      acc[year].push(article);
      return acc;
    }, {});

    const sortedYears = Object.keys(articlesByYear).sort((a, b) => b - a);

    let html = '<div class="press-grid">';

    sortedYears.forEach(year => {
      html += `<div class="press-grid__year">${year}</div>`;

      const articlesInYear = articlesByYear[year];

      if (this.groupBy === 'month_year') {
        const articlesByMonth = articlesInYear.reduce((acc, article) => {
          const month = new Date(article.date).toLocaleString('default', { month: 'long' });
          if (!acc[month]) {
            acc[month] = [];
          }
          acc[month].push(article);
          return acc;
        }, {});
        
        const sortedMonths = [...new Set(articlesInYear.map(a => new Date(a.date).toLocaleString('default', { month: 'long' })))];

        sortedMonths.forEach(month => {
          const articlesInMonth = articlesByMonth[month];
          html += `
            <div class="press-grid__group">
              <div class="press-grid__date">${month}</div>
              <div class="press-grid__items">
                ${articlesInMonth.map(article => this.renderArticle(article)).join('')}
              </div>
            </div>
          `;
        });
      } else {
        html += `
          <div class="press-grid__group">
            <div class="press-grid__date"></div>
            <div class="press-grid__items">
              ${articlesInYear.map(article => this.renderArticle(article)).join('')}
            </div>
          </div>
        `;
      }
    });

    html += '</div>';

    this.container.innerHTML = html;
  }
}

customElements.define('press-blog', PressBlog); 